import {
  fetchAllInvoicesFailure,
  fetchAllInvoicesSuccess,
  fetchInvoiceFailure,
  fetchInvoiceSuccess,
} from './InvoiceAction';
import {
  customerInvoiceViewAllEffect,
  invoiceViewAllEffect,
  invoiceViewEffect,
  vendorInvoiceViewAllEffect,
} from './InvoiceEffect';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  FETCH_ALL_INVOICE_REQUEST,
  FETCH_CUSTOMER_ALL_INVOICE_REQUEST,
  FETCH_INVOICE_REQUEST,
  FETCH_VENDOR_ALL_INVOICE_REQUEST,
} from './InvoiceType';
function* fetchInvoiceSaga(action) {
  console.log('fetchAllInvoiceRequest');
  try {
    const invoiceId = action.payload?.invoiceId;

    const response = yield call(invoiceViewEffect, invoiceId);

    const familyMembers = response.data.data || [];

    yield put(fetchInvoiceSuccess(familyMembers));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Failed to fetch family members';
    yield put(fetchInvoiceFailure(errorMessage));
  }
}

function* fetchInvoicesSaga() {
  try {
    const response = yield call(invoiceViewAllEffect);

    yield put(fetchAllInvoicesSuccess(response.data));
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.message
      : error.message;
    yield put(fetchAllInvoicesFailure(errorMessage));
  }
}
function* fetchCustomerInvoicesSaga(customerId) {
  try {
    const response = yield call(customerInvoiceViewAllEffect, customerId);

    yield put(fetchAllInvoicesSuccess(response.data));
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.message
      : error.message;
    yield put(fetchAllInvoicesFailure(errorMessage));
  }
}
function* fetchVendorInvoicesSaga(vendorId) {
  try {
    const response = yield call(vendorInvoiceViewAllEffect, vendorId);

    yield put(fetchAllInvoicesSuccess(response.data));
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.message
      : error.message;
    yield put(fetchAllInvoicesFailure(errorMessage));
  }
}
export default function* invoiceSaga() {
  yield takeLatest(FETCH_INVOICE_REQUEST, fetchInvoiceSaga);
  yield takeLatest(FETCH_ALL_INVOICE_REQUEST, fetchInvoicesSaga);
  yield takeLatest(
    FETCH_CUSTOMER_ALL_INVOICE_REQUEST,
    fetchCustomerInvoicesSaga
  );
  yield takeLatest(FETCH_VENDOR_ALL_INVOICE_REQUEST, fetchVendorInvoicesSaga);
}
